import { useLoyaltyOffersEmptyStatesQuery } from 'generated/sanity-graphql';

const useLoyaltyOffersEmptyStates = () => {
  const { data, loading } = useLoyaltyOffersEmptyStatesQuery({
    variables: {
      id: 'feature-loyalty-offers-ui-singleton',
    },
  });

  const offersEmptyStates = data?.LoyaltyOffersUI?.offersEmptyStates;

  return { offersEmptyStates, offersEmptyStatesLoading: loading };
};

export default useLoyaltyOffersEmptyStates;
